module.exports = __webpack_public_path__ + "e.no1.708b8911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/e.no1.jpg
// module id = peyI
// module chunks = 0